import { useQuery } from '@tanstack/react-query';
import { getPreInitDevices } from 'src/utils/api';
import { QUERY_KEY_MAP } from 'src/constants';

export const useGetPreInitDevices = () => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [QUERY_KEY_MAP.useGetPreInitDevices],
    queryFn: getPreInitDevices,
  });

  const totalPreInitDevices = data?.length || 0;

  const isEmptyData = !isLoading && !isError && totalPreInitDevices === 0;

  return {
    data,
    isLoading,
    isError,
    error,
    isEmptyData,
    totalPreInitDevices,
  };
};
